import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { APIService } from './api.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [APIService],
})
export class APIModule {}
